/* eslint-disable react/no-danger */
import {useEffect, useState} from 'react';
import DOMPurify from 'dompurify';
import useTerm from './useTerm';
import {PageTitle} from '../../../providers/PageDataProvider';
import {useI18n} from '../../../providers/I18nProvider';

const Term = () => {
	const [htmlContent, setHTMLContent] = useState({html: ''});
	const {data} = useTerm();
	const {i18n} = useI18n();
	async function createMarkUp() {
		const backendHtml = data?.data.body;
		return {html: backendHtml || ''};
	}
	createMarkUp().then((result) => setHTMLContent(result));

	useEffect(() => {
		const splashScreen = document.getElementById('splash-screen');
		splashScreen?.classList.add('hidden');
	}, []);

	return (
		<div className='px-12 py-6'>
			<PageTitle>{i18n('TERMCONDITION')}</PageTitle>
			<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(htmlContent.html)}} className='text-justify' />
		</div>
	);
};

export default Term;
